import type { ReactNode } from 'react';
import './Card.css';

interface CardProps {
  title?: string;
  icon?: ReactNode;
  variant?: 'default' | 'accent' | 'framework';
  children: ReactNode;
}

export function Card({ title, icon, variant = 'default', children }: CardProps) {
  return (
    <section className={`card card--${variant}`}>
      {title && (
        <h2 className="card__title">
          {icon && (
            <span className="card__icon" aria-hidden>
              {icon}
            </span>
          )}
          {title}
        </h2>
      )}
      <div className="card__body">{children}</div>
    </section>
  );
}

/**
 * Renders text with **bold** markers as <strong> elements.
 */
export function RichText({ text }: { text: string }) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <>
      {parts.map((part, index) => {
        if (part.startsWith('**') && part.endsWith('**')) {
          return <strong key={index}>{part.slice(2, -2)}</strong>;
        }
        return <span key={index}>{part}</span>;
      })}
    </>
  );
}
